import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import ConferenceAccomodation from '@components/ConferenceAccomodation/ConferenceAccomodation';
import ConferenceAttachmentsTemplate from '@components/ConferenceAttachments/ConferenceAttachments';
import ConferenceContactTemplate from '@components/ConferenceContact/ConferenceContact';
import ConferenceDescription from '@components/ConferenceDescription/ConferenceDescription';
import ConferenceGuestsTemplate from '@components/ConferenceGuests/ConferenceGuests';
import ConferenceHeaderTemplate from '@components/ConferenceHeader/ConferenceHeader';
import ConferenceInvitationsTemplate from '@components/ConferenceInvitations/ConferenceInvitations';
import ConferenceLecturers from '@components/ConferenceLecturers/ConferenceLecturers';
import ConferenceOrderTicketsTemplate from '@components/ConferenceOrderTickets/ConferenceOrderTickets';
import ConferencePartnersTemplate from '@components/ConferencePartners/ConferencePartners';
import ConferencePhotoGalleryTemplate from '@components/ConferencePhotoGallery/ConferencePhotoGallery';
import ConferencePreviousTemplate from '@components/ConferencePrevious/ConferencePrevious';
import ConferencePrivacyTemplate from '@components/ConferencePrivacy/ConferencePrivacy';
import ConferenceProgram from '@components/ConferenceProgram/ConferenceProgram';
import ConferenceReferencesTemplate from '@components/ConferenceReferences/ConferenceReferences';
import ConferenceReportageVideoTemplate from '@components/ConferenceReportageVideo/ConferenceReportageVideo';
import ConferenceTicketsTemplate from '@components/ConferenceTickets/ConferenceTickets';
import ConferenceVideoTemplate from '@components/ConferenceVideo/ConferenceVideo';
import ConferenceStreamTemplate from '@components/ConferenceStream/ConferenceStream';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import { getTypeTranslationById } from '@utils/conference.utils';
import { IColors, IConferenceItem } from '../../interfaces/Conference';
import { RootState } from '../../store';
import { theme } from '../../styles/theme';
import ContentTemplate from '../../ui/Content/Content';
import Cookies from 'js-cookie';
import { ACCESS_TOKEN_KEY_GUEST } from '../../constants';
import {
    Content,
    Desktop,
    IconDown,
    NoData,
    Section,
    Sidebar,
    SidebarContent,
    SidebarItem,
    SidebarLabel,
    SidebarMore,
    SidebarTitle,
} from './Conference.elements';

export interface ConferenceProps {
    conf: IConferenceItem;
}

const ConferenceTemplate: FC<ConferenceProps> = ({ conf }) => {
    const { t } = useTranslations();

    const isLoggedInState = useSelector((state: RootState) => state.ui.isLoggedIn);

    const [components, setComponents] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [activeSection, setActiveSection] = useState('');
    const [colors, setColors] = useState<IColors>();
    const [isOpen, setIsOpen] = useState(false);
    const [isHideMenu, setIsHideMenu] = useState(false);

    const handleMenuClick = (id: string) => {
        const top = document.getElementById(id).offsetTop;
        setIsOpen(false);
        setActiveSection(id);
        return window.scrollTo({ top: top - 100, behavior: 'smooth' });
    };

    useEffect(() => {
        if (conf) {
            setComponents(
                conf?.conference?.components.filter(
                    (item) => (!isLoggedIn && item?.type !== 9 && item?.type !== 10 && item?.type !== 18) || isLoggedIn || Cookies.get(ACCESS_TOKEN_KEY_GUEST)
                )
            );
        }
    }, [conf, isLoggedIn]);

    const onScroll = () => {
        const top = document.getElementById('footer').offsetTop;
        const current = window.pageYOffset;
        if(Number(current) > Number(top)){
            setIsHideMenu(true);
        }else{
            setIsHideMenu(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
    },[]);

    useEffect(() => {
        setIsLoggedIn(isLoggedInState);
    }, [isLoggedInState]);

    useEffect(() => {
        //kongres sw
        if (conf?.conference?.type === 0) {
            setColors({
                colorTitle: theme.colors.black,
                colorLine: theme.colors.conferenceEPImain,
                colorLink: theme.colors.conferenceEPImain,
                colorLight: theme.colors.conferenceEPIlight,
                colorLightest: theme.colors.darkLight,
                colorButton: theme.colors.green,
                colorButtonHover: theme.colors.green,
                colorNonLecture: theme.colors.conferenceGrayDark,
                colorBlockNumber: theme.colors.conferenceGrayLight,
                colorVideoLink: theme.colors.dark,
            });
        }
        //CS KONGRES
        if (conf?.conference?.type === 1) {
            setColors({
                colorTitle: theme.colors.conferenceCSmain,
                colorLine: theme.colors.conferenceCSsuppl,
                colorLink: theme.colors.conferenceCSmain,
                colorLight: theme.colors.conferenceCSlight,
                colorLightest: theme.colors.conferenceCSlightest,
                colorButton: theme.colors.conferenceCSsuppl,
                colorButtonHover: theme.colors.conferenceCSmain,
                colorNonLecture: theme.colors.conferenceCSsuppl,
                colorBlockNumber: theme.colors.conferenceCSsuppl,
                colorVideoLink: theme.colors.dark,
            });
        }
    }, []);

    return (
        <>
            <ContentTemplate withPadding>
                {conf?.dates?.length > 0 && (
                    <Desktop>
                        {components?.length > 0 && (
                            <Sidebar isHide={isHideMenu}>
                                <SidebarMore onClick={() => setIsOpen(!isOpen)}>
                                    {isOpen && (
                                        <>
                                            <IconDown name={Icons.ChevronUp} /> Skryt menu{' '}
                                        </>
                                    )}
                                    {!isOpen && (
                                        <>
                                            <IconDown name={Icons.ChevronDown} /> Zobrazit menu{' '}
                                        </>
                                    )}
                                </SidebarMore>
                                <SidebarContent isOpen={isOpen}>
                                    <SidebarTitle>{conf?.conference?.title}</SidebarTitle>

                                    {components.map((item) => (
                                        <SidebarItem key={`MenuSections${item.type}`}>
                                            {item.inMenu && (
                                                <SidebarLabel
                                                    onClick={() => handleMenuClick(`confSection${item.type}`)}
                                                    className={`${
                                                        activeSection === `confSection${item.type}` ? 'active' : ''
                                                    }`}
                                                >
                                                    {getTypeTranslationById(item.type)}
                                                </SidebarLabel>
                                            )}
                                        </SidebarItem>
                                    ))}
                                </SidebarContent>
                            </Sidebar>
                        )}

                        <Content>
                            {components?.map((item, index) => (
                                <Section key={`Sections${item.type}${index}`}>
                                    {item.type === 0 && (
                                        <ConferenceHeaderTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                            setActiveSection={setActiveSection}
                                        />
                                    )}
                                    {item.type === 10 && (
                                        <ConferenceVideoTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 9 && (
                                        <ConferenceAttachmentsTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 11 && (
                                        <ConferenceDescription
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 1 && (
                                        <ConferenceLecturers
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 2 && (
                                        <ConferenceProgram
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 4 && (
                                        <ConferenceTicketsTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 5 && (
                                        <ConferenceAccomodation
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 6 && (
                                        <ConferencePartnersTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 8 && (
                                        <ConferenceReferencesTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 12 && (
                                        <ConferencePrivacyTemplate key={`mainSection${item.type}`} colors={colors} />
                                    )}
                                    {item.type === 7 && (
                                        <ConferencePreviousTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}

                                    {item.type === 13 && (
                                        <ConferenceContactTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 3 && (
                                        <ConferenceInvitationsTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 14 && (
                                        <ConferenceOrderTicketsTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 15 && (
                                        <ConferenceGuestsTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 16 && (
                                        <ConferencePhotoGalleryTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 17 && (
                                        <ConferenceReportageVideoTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                    {item.type === 18 && (
                                        <ConferenceStreamTemplate
                                            key={`mainSection${item.type}`}
                                            colors={colors}
                                            conf={conf}
                                        />
                                    )}
                                </Section>
                            ))}
                        </Content>
                    </Desktop>
                )}

                {conf?.dates?.length === 0 && <NoData>{t('conference.general.noData')}</NoData>}
            </ContentTemplate>
        </>
    );
};

export default ConferenceTemplate;
